import { useCurrentFolderStore } from 'hooks/stores/useCurrentFolderStore'
import { useFolder } from 'hooks/queries/folders/useFolder'
import { useCurrentArticleMeta } from 'hooks/useCurrentArticleMeta'

export const useActiveFolder = () => {
  const { currentFolder } = useCurrentFolderStore()
  const currentDoc = useCurrentArticleMeta()
  const { data: currentDocFolder } = useFolder(currentDoc?.project_key || '', { enabled: !!currentDoc })

  return !!currentDoc ? currentDocFolder?.folder : currentFolder
}
